import React from 'react';
import { Tooltip, Button, Box, useTheme } from '@mui/material';
import { ArrowDownward, ArrowUpward, InfoOutlined } from '@mui/icons-material';

const SortingIcon = ({ direction }) =>
  direction === 'asc' ? <ArrowUpward style={{ fontSize: '18px' }} /> : <ArrowDownward style={{ fontSize: '18px' }} />;

const SortLabel = ({
  onSort,
  children: {
    props: {
      children: { value, tooltip }
    }
  },
  column: { sortDisabled },
  direction
}) => {
  const theme = useTheme();

  return (
    <>
      {sortDisabled && (
        <Box
          sx={{
            cursor: 'default',
            display: 'flex',
            alignItems: 'center',
            padding: 0
          }}
        >
          {tooltip && (
            <Tooltip title={tooltip || 'Here goes the Tooltip text'}>
              <InfoOutlined
                sx={{
                  marginRight: theme.spacing(1.5),
                  fontSize: '1rem'
                }}
              />
            </Tooltip>
          )}
          <b>{value}</b>
        </Box>
      )}
      {!sortDisabled && (
        <Button
          onClick={onSort}
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: 0,
            minWidth: 'auto',
            textTransform: 'none',
            ...theme.typography.label,
            cursor: 'pointer',
            color: 'inherit',
            '&:hover': {
              backgroundColor: 'transparent',
              opacity: 0.8
            },
            '&:focus-visible': {
              outline: '2px solid',
              outlineOffset: '2px'
            },
            '&:active': {
              backgroundColor: 'transparent'
            }
          }}
          aria-label={direction ? `Sort by ${value} ${direction === 'asc' ? 'descending' : 'ascending'}` : `Sort by ${value} ascending`}
          disableRipple
        >
          {tooltip && (
            <Tooltip title={tooltip || 'Here goes the Tooltip text'}>
              <InfoOutlined
                sx={{
                  marginRight: theme.spacing(1.5),
                  fontSize: '1rem'
                }}
              />
            </Tooltip>
          )}
          <b>{value}</b>
          {direction && <SortingIcon direction={direction} />}
        </Button>
      )}
    </>
  );
};

export default SortLabel;
